export const getTrackingEventMilestones = (fullConsolTrackingEvents) => {
    const consolTrackingEvents = [];
    if (fullConsolTrackingEvents && fullConsolTrackingEvents.length > 0) {
        let codePhrase = "";
        let consolTrackingEventId = 0;

        fullConsolTrackingEvents.forEach((trackingEvent) => {
            if (!consolTrackingEvents.some(p => p.portName === trackingEvent.portName)) {
                consolTrackingEvents.push(trackingEvent);
                codePhrase = trackingEvent.codePhrase;
            } else {
                if (consolTrackingEventId === 0) {
                    if (codePhrase.toUpperCase() === "ACT" && trackingEvent.codePhrase.toUpperCase() === "PLN") {
                        consolTrackingEventId = trackingEvent.consolTrackingEventID - 1;
                    }
                }
            }
        });

        if (consolTrackingEventId !== 0) {
            for (const cte of consolTrackingEvents.filter(w => w.consolTrackingEventID === consolTrackingEventId)) {
                cte.codePhrase = "PRT";
            }
        }
    }

    return consolTrackingEvents;
};

export const getTrackingEventMilestonesColours = (codePhrase) => {
    switch (codePhrase) {
        case 'ACT':
            return '#1DB35A';
        case 'PLN':
            return '#ef2927';
        case 'PRT':
            return '#ffa500'
        default:
            return '#1DB35A'
    }
};

export const getDelayReason = (reasonCode) => {
    switch (reasonCode) {
        case 'RDV':
            return 'Vessel adjusted its route to ensure safety amidst current geopolitical challenges in the Red Sea.';
        default:
            return ''
    }
};